import { useGetLmsTrainingReportParticipantsQuery, useAddLmsTrainingReportParticipantMutation, useDeleteLmsTrainingReportParticipantMutation } from '../../../../api';
import useTrainingReportSubListData from './useTrainingReportSubListData';

/**
 * Rapor detayındaki katılımcı satırları. Artık ortak `useTrainingReportSubListData` factory'sinin
 * ince bir sarmalayıcısı (bkz. o dosyadaki not). `kunnr` gönderilip bayi bulunamazsa backend 404
 * döner (doc §5.3) — bu durumda da genel hata mesajı gösterilir (factory'nin varsayılan
 * `formatErrorMessage` davranışı). Bkz. docs/LMS-Egitim-Raporlari-API.md §5.
 */
const useTrainingReportParticipantsData = (trainingReportId) => {
    const { itemsApi, isLoading, isFetching, isAdding, isDeleting, addItem, removeItem, refetch } = useTrainingReportSubListData({
        trainingReportId,
        useGetQuery: useGetLmsTrainingReportParticipantsQuery,
        useAddMutation: useAddLmsTrainingReportParticipantMutation,
        useDeleteMutation: useDeleteLmsTrainingReportParticipantMutation,
        i18nNamespace: 'participants'
    });

    return {
        participantsApi: itemsApi,
        isLoading,
        isFetching,
        isAdding,
        isDeleting,
        addParticipant: addItem,
        removeParticipant: removeItem,
        refetch
    };
};

export default useTrainingReportParticipantsData;
